import helpers from "@js/libs/helpers";

helpers.docReady(() => {

	let workContainer = document.querySelector('.Work-grid'),
		workEntryPage = document.querySelector('.workEntry'),
		filterButtons = document.querySelectorAll('.Filter-button');

	if (!workContainer) {
		return;
	}

	// Filter Group Button
	helpers.onClick('.Category-filter-button', function() {
		helpers.qsa('.Category-filter-button', (el) => {
			el.setAttribute('aria-pressed', 'false');
			this.setAttribute('aria-pressed', 'true');
		});

		// Toggle matching Filter Group Buttons
		let categoryFilter = this.getAttribute('data-filter');

		helpers.qsa('[data-filter-category]', (el) => {
			el.setAttribute('aria-hidden', 'true');

			if (el.getAttribute('data-filter-category') === categoryFilter) {
				el.setAttribute('aria-hidden', 'false');
			}
		});
	});

	const arrangeIso = function (selector) {

		// if we're showing all, just remove all `js-filtered` classes and be done
		if(selector == '*')
		{
			helpers.qsa('.Card', (el) => {
				helpers.removeClass(el, 'js-filtered');
			});

			return;
		}

		// add class to container that will in turn transition opacity to zero
		helpers.addClass(workContainer, 'js-filtering');

		// timeout should match the transition duration caused by adding class
		// @TODO: watch for transitionEnd??
		setTimeout(function() {

			let withSelector = [],
				withoutSelector = [],
				tempContainer = document.createElement('div');

			// run through each card and determine if it matches the selector or not,
			// pushing into array accordingly
			helpers.qsa('.Card', (el) => {

				if(helpers.hasClass(el, selector))
				{
					helpers.removeClass(el, 'js-filtered');
					withSelector.push(el);
				}
				else
				{
					helpers.addClass(el, 'js-filtered');
					withoutSelector.push(el);
				}

			});

			// any matching cards are appended first
			withSelector.forEach( (el) => {
				tempContainer.appendChild(el);
			});

			// now append  the rest
			withoutSelector.forEach( (el) => {
				tempContainer.appendChild(el);
			});

			// replace contents
			workContainer.innerHTML = tempContainer.innerHTML;

			// remove class, transitioning opacity back to 1
			helpers.removeClass(workContainer, 'js-filtering');

		}, 400);
	};

	// Filter Button click event
	helpers.onClick(filterButtons, function() {

		// already clicked, do nothing more
		if(this.getAttribute('aria-pressed') == 'true')
		{
			return;
		}

		// if on a single work entry and user clicks filter,
		// hide our work entry content and scroll down to the grid
		if (workEntryPage) {
			let workWrapper = document.querySelector('.Work-wrapper');
			let homeLink = document.querySelector('.Home-link');
			let workBorder = document.querySelector('.Work-border');
			let workSidebar = document.querySelector('.Work-sidebar');

			workSidebar.classList.add('h-0');

			// Hide work wrapper to make work grid visible
			workWrapper.style.height = workWrapper.scrollHeight + 'px';
			workWrapper.setAttribute('aria-hidden', 'true');
			window.setTimeout(function() {
				workWrapper.style.height = '0';
			}, 200);

			homeLink.classList.add('border-b');

			workBorder.classList.add('hidden');

			// don't do this again
			workEntryPage = false;
		}

		// update aria-pressed
		helpers.qsa(filterButtons, (el) => {
			el.setAttribute('aria-pressed', 'false');
			this.setAttribute('aria-pressed', 'true');
		});

		// now filter our isotope
		arrangeIso(this.getAttribute('data-filter'));
	});

	let workCategoryPage = document.querySelector('.workCategory');

	if (!workCategoryPage) {
		return;
	}

	let path = window.location.pathname.split('/');
	let filterSlug = path[path.length - 1];

	// turn slug into class selector
	arrangeIso(filterSlug);

}, 'filters');

